import { DiscountType } from '../../shared/types/discount.type';
import {
  DeliveryPointAddress,
  DeliveryPointSchedule,
  DeliveryPointType,
} from '../../delivery-points/types/delivery-point.type';

export const ORGANIZATION_TYPE = {
  COMPANY: 'company',
  CONCIERGERY: 'concierge',
} as const;

export type OrganizationType = typeof ORGANIZATION_TYPE[keyof typeof ORGANIZATION_TYPE];

export type OrganizationAddress = {
  street: string;
  zipCode: string;
  city: string;
  informations?: string;
};

export type OrganizationContact = {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string;
};

export type OrganizationOffer = {
  code: string;
  discount: number;
  reduction: DiscountType;
  isRestricted: boolean;
};

export type OrganizationMember = {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
};

export type OrganizationDeliveryPoint = {
  id: string;
  name: string;
  type: DeliveryPointType;
  address: DeliveryPointAddress;
  schedules: DeliveryPointSchedule[];
  invoicingNumber?: string;
};

export interface Organization {
  id: string;
  type: OrganizationType;
  name: string;
  description?: string;
  address: OrganizationAddress;
  siren?: string;
  vatNumber?: string;
  contact: OrganizationContact;
  members: OrganizationMember[];
  deliveryPoints: OrganizationDeliveryPoint[];
  offer: OrganizationOffer;
  createdAt: string;
  updatedAt: string;
}

type CreateOrganizationCommonInput = {
  type: OrganizationType;
  name: string;
  description?: string;
  address: OrganizationAddress;
  offer: Omit<OrganizationOffer, 'code'>;
  members: string[];
  deliveryPointIds?: string[];
};

export type CreateOrganizationContactPick = { contactId: string };

export type CreateOrganizationContactCreate = {
  contact: {
    firstname: string;
    lastname: string;
    email: string;
    phoneNumber: string;
  };
};

export type CreateOrganizationInput = CreateOrganizationCommonInput &
  (CreateOrganizationContactPick | CreateOrganizationContactCreate);
